import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import {
	canEmploymentTypeRequestOwnLeave,
	canEmploymentTypeRequestUnavailability,
	getAllowedPeopleLeaveTypes,
	isKnownPeopleEmploymentType,
} from '../../../common/utils/people/roster';
import { useUserContext } from '../../../common/utils/context';
import { GET_MY_EMPLOYEE_PROFILE_MOBILE } from '../../graphql/people';

// Which self-service requests the signed-in employee may make (Leave page and request form).
const useMyRosterProfile = () => {
	const { isAVC } = useUserContext();
	const { data, loading } = useQuery(GET_MY_EMPLOYEE_PROFILE_MOBILE, {
		skip: !isAVC,
		fetchPolicy: 'cache-and-network',
	});
	const employmentType = data?.getMyEmployeeProfile?.employmentType;
	const employmentTypeReady = !loading && isKnownPeopleEmploymentType(employmentType);
	const allowedLeaveTypes = useMemo(() => getAllowedPeopleLeaveTypes(employmentType), [employmentType]);

	return {
		isLoading: loading && !data,
		employmentTypeReady,
		canRequestUnavailability: employmentTypeReady && canEmploymentTypeRequestUnavailability(employmentType),
		canRequestLeave: employmentTypeReady && canEmploymentTypeRequestOwnLeave(employmentType),
		allowedLeaveTypes,
	};
};

export default useMyRosterProfile;
